import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/repo/client/src/components/global/scoreboard.tsx");
